export var AnimationState;
(function (AnimationState) {
    /**
     * State at the beginning of the animation (e.g. door is closed)
     */
    AnimationState["Initial"] = "Initial";
    /**
     * In the process of executing the animation (e.g. door is opening)
     */
    AnimationState["Running"] = "Running";
    /**
     * State after complete animation (e.g. door is open)
     */
    AnimationState["Animated"] = "Animated";
})(AnimationState || (AnimationState = {}));
//# sourceMappingURL=animation-spot.js.map